export const routes = (prefix = `auditing`) => [
    {
        name: `${prefix}.morgue.index`,
        path: `/${prefix}/morgue`,
        component: () => import('./Index.vue'),
        meta: {
            requiresAuth: true,
            permissions: {
                PageName: `${prefix}.morgue.index`,
                PageDescription: "Audits - Morgue",
            },
        },
    },
];
